import _failsafe from "./failsafe";
import _null from "../type/null";
import _bool from "../type/bool";
import _int from "../type/int";
import _float from "../type/float";
var exports = {};
exports = _failsafe.extend({
  implicit: [_null, _bool, _int, _float]
});
export default exports;